export default __webpack_public_path__ + "media/zurb/img/services/services/data-driven-websites-img-53d7edf83c81e2bfe81f3a120ac5bac2.png";